<template>
  <div class="driving-data-device">
    <p class="driving-data-device__title">FILTER</p>
    <form class="driving-data-device__form" @submit.prevent="fetchDeviceStatistics(null)">
      <div class="driving-data-device__input">
        <base-date-picker v-model="startDate" />
      </div>
      <div class="driving-data-device__input">
        <base-time-picker v-model="startTime" format="hh:mm A"  valueFormat="HH:mm" />
      </div>
      <div class="driving-data-device__input">
        <base-date-picker v-model="endDate"/>
      </div>
      <div class="driving-data-device__input">
        <base-time-picker v-model="endTime" format="hh:mm A"  valueFormat="HH:mm" />
      </div>
      <base-button :disabled="loading">
        <template v-if="!loading">Apply</template>
        <clip-loader color="white" size="15px" :loading="loading" />
      </base-button>
    </form>
    <p class="driving-data-device__title">HEAT MAP</p>
    <heatmap
      v-if="deviceHeatmapPoints"
      class="driving-data-device__heatmap"
      :initialPoints="deviceHeatmapPoints"
      :needBound="deviceHeatMapPointsNeedBound"
      @zoom-changed="zoomChanging"
    />
  </div>
</template>

<script>
import BaseDatePicker from '@/components/common/BaseDatePicker.vue'
import BaseTimePicker from '@/components/common/BaseTimePicker.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import Heatmap from '@/components/partials/Heatmap.vue'
import moment from 'moment'
import toast from '@utils/toast.js'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'


export default {
  name: 'DrivingDateDevice',
  components: { BaseTimePicker, BaseDatePicker, BaseButton, Heatmap, ClipLoader },
  props: {
    deviceId: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      deviceHeatmapPoints: [],
      deviceHeatMapPointsNeedBound: false,
      loading: false,
    }
  },
  mounted() {
    this.setInitialDate()
    this.fetchDeviceStatistics()
  },
  methods: {
    async fetchDeviceStatistics(zoom) {
      const url = '/admin/get/device/stats'
      const body = {
        data: {
          device_id: this.deviceId,
          from: `${this.startDate} ${this.startTime}`,
          till: `${this.endDate} ${this.endTime}`,
          zoom
        }

      }
      try {
        this.loading = true
        const res = await this.request(url, 'POST', body)
        if (res.code === 0) {
          this.deviceHeatmapPoints = res.data.points ?.coordinates || []
          this.deviceHeatMapPointsNeedBound = !zoom
        } else toast.errorMessage(response.message)

      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false
      }

    },

    setInitialDate() {
      const dateLast = moment().subtract(1,'months').format('YYYY-MM-DD')
      const dateNow = moment().format('YYYY-MM-DD')
      const time = moment().format('HH:mm')
      this.startDate = dateLast
      this.startTime = time
      this.endDate = dateNow
      this.endTime = time
    },
    zoomChanging(zoom){
      this.fetchDeviceStatistics(zoom)
    }
  }

}
</script>

<style>
  .driving-data-device__title {
    color: #2856B8;
    font-size: 14px;
    margin-bottom: 0;
    font-weight: initial;
    text-align: left;
  }
  .driving-data-device__form {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
  }

  .driving-data-device__input {
    width: 175px;
    margin-right: 15px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .driving-data-device__heatmap {
    width: 100%;
    height: 550px;
    margin-top: 15px;
  }


</style>
